import {HandleButtonStylesPermissionsResp, HandlePermissionsProps} from './types';

const getButtonStyleByPermission = ({
	state,
}: HandlePermissionsProps): HandleButtonStylesPermissionsResp => {
	const defaultState: HandleButtonStylesPermissionsResp = {
		iconName: 'location-default',
		isDisabled: false,
	};
	const blockedState: HandleButtonStylesPermissionsResp = {
		iconName: 'location-blocked',
		isDisabled: true,
	};
	switch (state) {
		case 'granted':
			return defaultState;
		case 'denied':
			return blockedState;
		case 'prompt':
			return defaultState;
		default:
			return defaultState;
	}
};

export {getButtonStyleByPermission};
